'use client';

import React from 'react';
import { useTranslations } from '../../../../contexts/translation.context';
import { RevshareAccount } from '../types';

interface IndicatorsCellProps {
  account: RevshareAccount;
}

const IndicatorsCell: React.FC<IndicatorsCellProps> = ({ account }) => {
  const { t } = useTranslations();

  const formatNumber = (value: number | undefined) => {
    return (value ?? 0).toLocaleString('ru-RU').replace(/,/g, ' ');
  };

  return (
    <div className="flex flex-col gap-1 py-2">
      <div className="flex items-center gap-1 text-sm text-auth-muted">
        <span>{t('partner.partnerAccounts.subscribers')}:</span>
        <span className="text-auth-ink text-sm font-semibold leading-4">
          {formatNumber(account.subscribers)}
        </span>
      </div>
      <div className="flex items-center gap-1 text-sm text-auth-muted">
        <span>{t('partner.partnerAccounts.likes')}:</span>
        <span className="text-auth-ink text-sm font-semibold leading-4">
          {formatNumber(account.likes)}
        </span>
      </div>
      <div className="flex items-center gap-1 text-sm text-auth-muted">
        <span>{t('partner.partnerAccounts.posts')}:</span>
        <span className="text-auth-ink text-sm font-semibold leading-4">
          {formatNumber(account.posts)}
        </span>
      </div>
      <div className="flex items-center gap-1 text-sm text-auth-muted">
        <span>{t('partner.partnerAccounts.mutualSubscribers')}:</span>
        <span className="text-auth-ink text-sm font-semibold leading-4">
          {formatNumber(account.mutual_subscribers)}
        </span>
      </div>
    </div>
  );
};

export default IndicatorsCell;
